var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7162 21.5901H2.31728C1.55102 21.5901 0.931641 20.9682 0.931641 20.1989V4.89537C0.931641 4.12602 1.55102 3.50414 2.31728 3.50414H3.70292V6.28659H7.85984V3.50414H16.1737V6.28659H20.3306V3.50414H21.7162C22.4825 3.50414 23.1019 4.12602 23.1019 4.89537V20.1989C23.1019 20.9682 22.4825 21.5901 21.7162 21.5901ZM20.3306 9.06905H3.70292V18.8077H20.3306V9.06905ZM13.4024 17.4164H10.6311V14.634H13.4024V17.4164ZM9.24547 17.4164H6.4742V14.634H9.24547V17.4164ZM17.5593 13.2427H14.788V10.4603H17.5593V13.2427ZM13.4024 13.2427H10.6311V10.4603H13.4024V13.2427ZM6.4742 4.89537H5.08856V1.40895C5.08856 1.03053 5.39617 0.72168 5.77722 0.72168H5.78969C6.16658 0.72168 6.4742 1.03053 6.4742 1.40895V4.89537ZM18.9449 4.89537H17.5593V1.40895C17.5593 1.03053 17.8669 0.72168 18.248 0.72168H18.2604C18.6373 0.72168 18.9449 1.03053 18.9449 1.40895V4.89537Z",
    fill: "#F0EAE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal);
export default __webpack_public_path__ + "static/media/cal.752f0cf1dc2b2bc76d82699ed6bd919d.svg";
export { ForwardRef as ReactComponent };